import React from 'react';

export default React.createContext({
  isAuthenticated: false,
  user: undefined,
  loading: true,
  popupOpen: false,
  login: () => {},
  handleRedirectCallback: () => {},
  getIdTokenClaims: () => {},
  loginWithRedirect: () => {},
  getTokenSilently: () => {},
  getTokenWithPopup: () => {},
  logout: () => {},
  can: () => false,
});
